import ProductBase from './productBase.js';

export default class CommonBuy extends ProductBase {
  buyUrl = 'https://common-buy.aliyun.com';

  match() {
    return true;
  }

  getDefaultConfig() {
    return {
      specCode: this.accessories.specCode,
      chargeType: 'PREPAY', //付费类型
      orderType: 'BUY',
      autoRenew: false,
      orderParams: {},
      quantity: '1' //购买数量
    };
  }

  setPeroid(config, number, type) {
    let commodity = config.commodities[0];

    commodity.pricingCycle = type;
    commodity.duration = number;
  }



  getConfig(commodityValue) {
    let commodity = this.getDefaultConfig();

    commodity.components = getComponents(commodityValue || this.commodityValue, this.commodityCode);
    let config = {
      commodities: [commodity]
      // fromApp: $ACE.isMoblie && $ACE.isMoblie() && 'app' || 'CommonBuy'
    };

    if (this.activityId) {
      commodity.orderParams = {
        order_activity_id: this.activityId
      };
    }
    return config;
  }

  getBuyConfig() {
    let params = Object.assign({}, this.commodityValue);
    delete params.price;

    let buyConfig = {
      commodityCode: this.accessories.commodityCode,
      specCode: this.accessories.specCode,
      request: JSON.stringify(params)
    };

    return buyConfig;
  }

  getCartConfig() {
    let me = this;
    let commodityParams = me.config.commodities.map((item) => {
      const tempValue = {
        ...me.commodityValue
      };
      for (const key in tempValue) {
        if (shouldFilterKey(me.accessories.commodityCode, key)) {
          delete tempValue[key];
        }
      }
      let itemConfig = {
        commodityCode: me.accessories.commodityCode,
        instanceType: '',
        filterStamp: '',
        specCode: item.specCode,
        refundSpecCode: '',
        sign: '',
        data: {
          duration: item.duration,
          pricingCycle: item.pricingCycle,
          quantity: this.formatQuantity(item),
          orderType: item.orderType,
          chargeType: item.chargeType
        },
        components: tempValue
      };
      return itemConfig;
    });
    return {
      commodityParams: commodityParams,
      productCode: 'common-buy'
    };
  }

  getPriceConfig() {
    return {
      commodityCode: this.accessories.commodityCode,
      param: Object.assign({}, this.config)
    };
  }
}

function shouldFilterKey(commodityCode, key) {
  // price和order_num不能作为prop传递
  if (key == 'price' || key == 'order_num') {
    return true;
  }
  // 加入处理短信的黑名单
  if (key == 'ord_time' && commodityCode === 'newdysmsbag') {
    return true;
  }
  return false;
}

function getComponents(commodityValue, commodityCode) {
  let components = [];

  Object.keys(commodityValue).forEach((key) => {
    if (shouldFilterKey(commodityCode, key)) {
      return;
    }
    let setting = commodityValue[key];

    let instanceProperty = [];

    if (Array.isArray(setting)) {
      // 多个的情况目前还未出现，暂时不处理
      // item.map((item) => {
      //  return {
      //     code: key,
      //     value: item.value
      //   }
      // });
    } else {
      instanceProperty.push({
        code: key,
        value: setting
      });
    }

    components.push({
      componentCode: key, //配件code
      instanceProperty: instanceProperty
    });

  });

  return components;
}


// const WhiteList = [
//   "ossbag",
//   "cas_mayi",
//   "otsbag",
//   "mqc",
//   "ceping",
//   "cdnflowbag",
//   "cloudap",
//   "dmbag",
//   "prepaid_ads",
//   "prepaid_edas",
//   "oceanbase",
//   "nas",
//   "onsMqtt",
//   "sls",
//   "sls_intl",
//   "afsbag",
//   "mnsbag",
//   "smsbag",
//   "cas",
//   "waf",
//   "sas",
//   "supportplan_intl",
//   "individual_intl",
//   "httpdnsbag",
//   "dtspre",
//   "waf_intl",
//   "dtspost",
//   "vipaegis",
//   "eip",
//   "ddosBag",
//   "drdspre",
//   "sos",
//   "slb",
//   "ptsbag",
//   "ddosBag_intl",
//   "hsm_intl",
//   "mobsec_yr",
//   "mobsec_qty",
//   "GreenplumPost",
//   "ddosflowtest",
//   "vipaegis_intl",
//   "afscode",
//   "nat_gw",
//   "bandwidth_package",
//   "mobsec_yr_intl",
//   "mobsec_qty_intl",
//   "cpsbag",
//   "hsm",
//   "eip_intl",
//   "slb_intl",
//   "eip_jp",
//   "slb_jp",
//   "supportplan_jp",
//   "mssp",
//   "ddosBag_jp",
//   "mobsec_yr_jp",
//   "mobsec_qty_jp",
//   "cdnflowbag_intl",
//   "individual_jp",
//   "cdnforpack",
//   "eip_pre",
//   "vpn_pre",
//   "prophet",
//   "ossforpack",
//   "odps",
//   "odpsplus",
//   "supportplan",
//   "naspackage",
//   "datav",
//   "nls",
//   "cdn_coupon_v1_upsale",
//   "common_coupon_partner",
//   "common_coupon_shenzhen",
//   "common_coupon_cbm",
//   "common_coupon_upsale",
//   "waf_cainiao",
//   "eip_cainiao",
//   "slb_cainiao",
//   "odps_cainiao",
//   "odpsplus_cainiao",
//   "receng",
//   "portrait",
//   "bandwidth_package_cainiao",
//   "nat_gw_cainiao",
//   "stream",
//   "dmspre",
//   "cdn",
//   "cdn_intl",
//   "cdn_jp",
//   "hbasepost",
//   "eip_mayi",
//   "dtspost_mayi",
//   "oceanbase_mayi",
//   "odps_intl",
//   "eprofile_hi",
//   "odpsplus_intl",
//   "aegis_for_xuji",
//   "ess",
//   "sca",
//   "ess_intl",
//   "onspre",
//   "slbpre",
//   "ess_jp",
//   "quickbi",
//   "dtspre_intl",
//   "dtspost_intl",
//   "quickbi_weblog_dp",
//   "vipaegis_cainiao",
//   "sas_cainiao",
//   "cdn_cainiao",
//   "cdnflowbag_cainiao",
//   "oss",
//   "oss_intl",
//   "oss_mayi",
//   "oss_cainiao",
//   "oss_jp",
//   "drdspre_cainiao",
//   "slb_mayi",
//   "waf_mayi",
//   "vipaegis_mayi",
//   "sas_mayi",
//   "vod",
//   "openad",
//   "ddosBag_mayi",
//   "dtspre_mayi",
//   "eip_pre_mayi",
//   "datav_cainiao",
//   "slbpre_cainiao",
//   "flowbag_intl",
//   "kvstore",
//   "prepaid_kvstore",
//   "slbpre_mayi",
//   "eprofile_risk",
//   "fc",
//   "mqcbag",
//   "eip_pre_cainiao",
//   "mqcremotebag",
//   "kms",
//   "cas_cainiao",
//   "hotfix",
//   "feedback",
//   "ddosBag_cainiao",
//   "GreenplumPost_intl",
//   "ess_cainiao",
//   "vodtranssdbag",
//   "face",
//   "image",
//   "CloudDesktop",
//   "alimail",
//   "dtspre_cainiao",
//   "prophet_brand",
//   "prepaid_ads_mayi",
//   "cas_intl",
//   "newcdpbag",
//   "vipaegispost",
//   "cdpbag",
//   "vipaegisbag",
//   "hsm_cainiao",
//   "cdnflowbag_intl_vdf",
//   "dypns_marketing_bag",
//   "dypns_verify_bag"
// ];


// WEBPACK FOOTER //
// ./lib/services/product/commonBuy.js